// src/components/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Wait for layout to finish
    const scroll = () => {
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    };

    // Slight delay ensures layout is ready
    const timeout = setTimeout(scroll, 50);
    return () => clearTimeout(timeout);
  }, [pathname, hash]);

  return null;
}